import spacetime from "spacetime";

import { IChartElement, IMtDropdownData } from "@/interfaces";
import { ICheckListData } from "@/routes/easog/mt-easog-checklist-dialog";

export const filterByOptions: IMtDropdownData[] = [
  {
    name: "Ack'ed",
    value: "acked",
  },
  {
    name: "Unack'ed",
    value: "unacked",
  },
  {
    name: "In Alarm",
    value: "inalarm",
  },
  {
    name: "Last Week",
    value: "lastweek",
  },
  {
    name: "Last 24H",
    value: "last24h",
  },
  {
    name: "OK",
    value: "ok",
  },
  {
    name: "Follow",
    value: "follow",
  },
];

export const HULL301CamData = {
  cards: [
    {
      title: "Power System",
      dataSpecs: [
        "639_3_700_8b",
        "639_3_700_9b",
        "639_3_700_10b",
        "639_3_700_11b",
        "639_3_700_12b",
      ],
    },
    {
      title: "DP",
      dataSpecs: [
        "639_3_700_18b",
        "639_3_700_19b",
        "639_3_700_20b",
        "639_3_700_22b",
        "639_3_700_23b",
      ],
    },
    {
      title: "Thrusters and Propulsion",
      dataSpecs: ["639_3_700_13b", "639_3_700_14b", "639_3_700_15b"],
    },
    {
      title: "AMS",
      dataSpecs: ["639_3_700_21b", "639_3_700_24b"],
    },
  ],

  dataSpecs: {
    MainMode: {
      label: "",
      eq: "{DPS|11405}",
    },
    SubMode: {
      label: "",
      eq: "{DPS|11406}",
    },
    AlongDeviation: {
      label: "",
      eq: "{DPS|11407}",
    },
    AthwartDeviation: {
      label: "",
      eq: "{DPS|11408}",
    },
    HeadingDeviation: {
      label: "",
      eq: "{DPS|11409}",
    },
    Heading: {
      label: "",
      eq: "{DPS|11599}",
    },
    HeadingSetPoint: {
      label: "",
      eq: "{DPS|11602}",
    },
    WindDirection: {
      label: "",
      eq: "{DPS|11593}",
    },
    CurrentDirection: {
      label: "",
      eq: "{DPS|11595}",
    },
    Thruster1: {
      label: "",
      eq: "{TCS|3293}",
    },
    Thruster2: {
      label: "",
      eq: "{TCS|3334}",
    },
    Thruster3: {
      label: "",
      eq: "{TCS|3375}",
    },
    Thruster4: {
      label: "",
      eq: "{TCS|3416}",
    },
    Thruster5: {
      label: "",
      eq: "{TCS|3457}",
    },
    Thruster6: {
      label: "",
      eq: "{TCS|3498}",
    },
    Thruster7: {
      label: "",
      eq: "{TCS|3539}",
    },
    Thruster8: {
      label: "",
      eq: "{TCS|3580}",
    },
    Thruster9: {
      label: "",
      eq: "{TCS|3621}",
    },
    Thruster10: {
      label: "",
      eq: "{TCS|3662}",
    },
    "639_3_600_1b": {
      label: "GEN1 or GEN2 are running and breaker closed",
      eq: "3,=if({IBS|1215}+{IBS|1098}>1,1,0)+(if({IBS|1378}+{IBS|1272}>1,1,0))",
    },
    "639_3_600_2b": {
      label: "GEN3 or GEN4 are running and breaker closed",
      eq: "3,=if({IBS|1609}+{IBS|1709}>1,1,0)+(if({IBS|1552}+{IBS|1435}>1,1,0))",
    },
    "639_3_600_3b": {
      label: "vessel is in either DP or Joystick mode",
      eq: "3,=(if(or({DPS|11405}=8,{DPS|11405}=4),1,0))",
    },
    "639_3_600_4b": {
      label: 'number of thrusters "in use"',
      eq: "3,=((((if({DPS|11613}=3,1,0)+if({DPS|11614}=3,1,0)+if({DPS|11615}=3,1,0)+if({DPS|11616}=3,1,0)+if({DPS|11617}=3,1,0)))))",
    },
    "639_3_600_5b": {
      label: "BTT1 TCS/DP Lever Command",
      eq: "3,=if({639_1_65_25}>0,{639_1_9_9},{639_1_9_14})",
    },
    "639_3_600_6b": {
      label: "number of thruster lever commands set at zero",
      eq: "3,=((((if({639_1_10_7}=0,1,0)+if({639_1_24_21}=0,1,0)+if({639_1_56_11}=0,1,0)+if({639_1_67_30}=0,1,0)+if({639_3_600_5b}=0,1,0)))))",
    },
    "639_3_600_7b": {
      label: "number of sensors available",
      eq: "3,=((((((((if({DPS|11541}=3,1,0)+if({DPS|11542}=3,1,0)+if({DPS|11543}=3,1,0)+if({DPS|11566}=3,1,0)+if({DPS|11565}=3,1,0)+if({DPS|11566}=3,1,0)+if({DPS|11581}=3,1,0)+if({DPS|11582}=3,1,0)+if({DPS|11583}=3,1,0)))))))))",
    },
    "639_3_600_8b": {
      label: "Maintaining greater than 10m from Facility",
      eq: "3,=if({639_9_1_7}>10,1,0)",
    },
    "639_3_600_9b": {
      label: "Vessel within 250M Zone and on DP",
      eq: '3,=(if(and({639_3_1_1}="dp",{639_9_1_6}>0),1,0))',
    },
    "639_3_700_1b": {
      label: "",
      eq: "3,=if((abs({639_3_1_259})-abs({639_3_1_269}))>10,0,1)",
    },
    "639_3_700_2b": {
      label: "",
      eq: "3,=if((abs({639_3_1_260})-abs({639_3_1_270}))>10,0,1)",
    },
    "639_3_700_3b": {
      label: "",
      eq: "3,=if((abs({639_3_1_261})-abs({639_3_1_271}))>10,0,1)",
    },
    "639_3_700_4b": {
      label: "",
      eq: "3,=if((abs({639_3_1_262})-abs({639_3_1_272}))>10,0,1)",
    },
    "639_3_700_5b": {
      label: "",
      eq: "3,=if((abs({639_3_1_263})-abs({639_3_1_273}))>10,0,1)",
    },
    "639_3_700_6b": {
      label: "",
      eq: "3,=if({639_9_1_5}=0,1,{639_3_600_3b})",
    },
    "639_3_700_8b": {
      label: "Bus-Tie Breaker (480) VAC Open for DP2 Operations",
      eq: "3,=if({IBS|2491}=0,1,0)",
    },
    "639_3_700_9b": {
      label: "Bus-Tie Breaker (4160 kv) Bus-Tie 1 Open / Bus Tie 2 Closed",
      eq: "3,=if(and({IBS|2434}=0,{IBS|2446}=1),1,0)",
    },
    "639_3_700_10b": {
      label: "Diesel Generators - 1 & 2 Port Bus (min 1 online)",
      eq: "3,=if({639_3_600_1b}>0,1,0)",
    },
    "639_3_700_11b": {
      label: "Diesel Generator - 3 & 4 STBD Bus (min 1 online)",
      eq: "3,=if({639_3_600_2b}>0,1,0)",
    },
    "639_3_700_12b": {
      label:
        "E - Generator (480 VAC Switchboard) -  Tie Breaker B Closed - Service Mode Switch Off",
      eq: "3,=if(and({IBS|2505}=1,{IBS|631}=0),1,0)",
    },
    "639_3_700_13b": {
      label: "Thrusters, Main Props available, selected to DP",
      eq: "3,=if({639_3_600_4b}=4,1,0)",
    },
    "639_3_700_14b": {
      label: "BTT#1 supplied from STBD switchboard",
      eq: "3,=if({IBS|2434}=0,1,0)",
    },
    "639_3_700_15b": {
      label: "VFD Alarms - No Active Alarms Present",
      eq: "3,=1=1",
    },
    "639_3_700_16b": {
      label: "",
      eq: "3,=if({639_9_1_6}<1,1,{639_3_600_9b})",
    },
    "639_3_700_17b": {
      label: "",
      eq: "3,=if({639_9_1_6}=1,{639_3_600_8b},1)",
    },
    "639_3_700_18b": {
      label: "All propulsion staying under water",
      eq: "3,=if(({IBS|441}+{IBS|439})<20,0,1)",
    },
    "639_3_700_19b": {
      label: "MT System Vessel Response all set to 100%",
      eq: "3,=if(({DPS|11848}+{DPS|11849}+{DPS|11850})=300,1,0)",
    },
    "639_3_700_20b": {
      label: "DP Sensors- Gyros, VRUs, wind sensors - all available",
      eq: "3,=if({639_3_600_7b}=9,1,0)",
    },
    "639_3_700_21b": {
      label: "Fuel Tanks Separate with no cross connections",
      eq: "3,=if(({IBS|1026}+{IBS|1027}+{IBS|1040}+{IBS|1018}+{IBS|1028}+{IBS|1030}+{IBS|1029}+{IBS|1031})>0,0,1)",
    },
    "639_3_700_22b": {
      label: "DP Network Monitor",
      eq: "3,={DPS|11408}", // Possible placeholders
    },
    "639_3_700_23b": {
      label: "GNSS signal Level",
      eq: "3,={DPS|11408}", // Possible placeholders
    },
    "639_3_700_24b": {
      label: "All Watertight doors and openings secured",
      eq: "3,=if({IBS|2747}+{IBS|2748}+{IBS|2749}+{IBS|2750}+{IBS|2751}+{IBS|2752}+{IBS|2753}+{IBS|2754}+{IBS|2755}+{IBS|2756}+{IBS|2757}+{IBS|2758}+{IBS|2759}+{IBS|2760}+{IBS|2761}+{IBS|2762}+{IBS|2763}+{IBS|2764}+{IBS|2765}+{IBS|2766}+{IBS|2767}+{IBS|2768}=22,1,0)",
    },
    "639_3_*2_1": {
      label: "Bow Thruster 1 RPM",
      eq: "3,={639_3_1_229}*1194",
    },
    "639_3_*2_2": {
      label: "Bow Thruster 1 VFD%",
      eq: "3,={639_3_1_229}*100",
    },
    "639_3_*1_1": {
      label: "Bow Thruster 1 Thrust",
      eq: "3,={639_3_1_269}*.11",
    },
    "639_3_*3_1": {
      label: "Bow Thruster 2 RPM",
      eq: "3,={639_3_1_230}*1194",
    },
    "639_3_*3_2": {
      label: "Bow Thruster 2 VFD%",
      eq: "3,={639_3_1_230}*100",
    },
    "639_3_*4_1": {
      label: "Bow Thruster 2 Thrust",
      eq: "3,={639_3_1_270}*.11",
    },
    "639_3_*7_1": {
      label: "Bow Azi RPM",
      eq: "3,={639_3_1_231}*1200",
    },
    "639_3_*7_2": {
      label: "Bow Azi VFD%",
      eq: "3,={639_3_1_231}*100",
    },
    "639_3_*8_1": {
      label: "Bow Azi Thrust",
      eq: "3,={639_3_1_271}*.11",
    },
    "639_3_*9_1": {
      label: "Port Z-Drive RPM",
      eq: "3,={639_3_1_232}*680",
    },
    "639_3_*9_2": {
      label: "Port Z-Drive VFD%",
      eq: "3,={639_3_1_232}*100",
    },
    "639_3_*10_1": {
      label: "Port Z-Drive Thrust",
      eq: "3,={639_3_1_272}*.30",
    },
    "639_3_*11_1": {
      label: "STBD Z-Drive RPM",
      eq: "3,={639_3_1_233}*680",
    },
    "639_3_*11_2": {
      label: "STBD Z-Drive VFD%",
      eq: "3,={639_3_1_233}*100",
    },
    "639_3_*12_1": {
      label: "STBD Z-Drive Thrust",
      eq: "3,={639_3_1_273}*.30",
    },
    "639_3_*1_9": {
      label: "Speed Along Knots",
      eq: "3,={639_3_1_9}*1.94384",
    },
    "639_1_100_9b": {
      label: "",
      eq: "3,=0",
    },
    "639_1_100_10b": {
      label: "",
      eq: "3,=0",
    },
    "639_1_100_1b": {
      label: "",
      eq: "3,=if(or({639_1_42_26}+{639_1_44_21}>0,{639_1_65_25}+{639_1_66_2}+{639_1_100_3b}>2),1,0)",
    },
    "639_1_100_2b": {
      label: "",
      eq: "3,={639_1_65_25}+{639_1_66_2}",
    },
    "639_1_100_3b": {
      label: "",
      eq: "3,=if(or({639_1_46_29}+{639_1_48_25}>0,{639_1_65_25}+{639_1_66_2}+{639_1_100_1b}>2),1,0)",
    },
    "639_1_800_1b": {
      label: "",
      eq: "3,=if({639_1_65_25} =1,{639_1_9_17},{639_1_9_21})",
    },
    "639_1_800_2b": {
      label: "",
      eq: "3,=if({639_1_65_25} =1,{639_1_9_18},{639_1_9_22})",
    },
    "639_1_800_3b": {
      label: "",
      eq: "3,={639_1_800_2b}/1320*16.2",
    },
    "639_1_100_6b": {
      label: "",
      eq: "3,=0",
    },
    "639_1_800_4b": {
      label: "VFD",
      eq: "3,=if({639_1_9_20}+({639_1_9_26}) >0,1,0)",
    },
    "639_1_100_7b": {
      label: "",
      eq: "3,=0",
    },
    "639_1_100_8b": {
      label: "",
      eq: "3,=0",
    },
    "639_1_100_12b": {
      label: "Port Trans",
      eq: "3,={639_1_66_6}",
    },
    "639_1_100_13b": {
      label: "STBD Trans",
      eq: "3,={639_1_66_9}",
    },
    "639_1_400_1b": {
      label: "",
      eq: "3,=if(or({639_1_400_5b}+{639_1_67_12}>1,{639_1_400_2b}+{639_1_67_16}>0),1,0)",
    },
    "639_1_400_2b": {
      label: "",
      eq: "3,=if(or({639_1_67_13}+{639_1_66_6}>1,{639_1_67_14}+{639_1_29_18}>1),1,0)",
    },
    "639_1_400_3b": {
      label: "",
      eq: "3,=if(or({639_1_29_18}+{639_1_67_18}>1,{639_1_67_17}+{639_1_66_9}>1),1,0)",
    },
    "639_1_400_5b": {
      label: "",
      eq: "3,=if(or({639_1_400_1b}+{639_1_67_12}>1,{639_1_400_3b}+{639_1_67_16}>0),1,0)",
    },
    "639_3_400_1b": {
      label: "",
      eq: "3,=abs({639_3_1_386})",
    },
    "639_3_400_2b": {
      label: "",
      eq: "3,=abs({639_3_1_387})",
    },
    "639_3_400_3b": {
      label: "",
      eq: "3,=abs({639_3_1_388})",
    },
    "639_3_#400_19": {
      label: "",
      eq: "3,=abs({639_3_1_389})",
    },
    "639_1_500_1b": {
      label: "",
      eq: "3,=(abs({639_3_1_386})+(abs({639_3_1_387})+(if(({639_1_65_25}+{639_3_500_2b})>1,1,0))))",
    },
    "639_3_400_6b": {
      label: "",
      eq: "3,={639_3_1_392}",
    },
    "639_3_400_7b": {
      label: "",
      eq: "3,={639_3_1_393}",
    },
    "639_3_400_8b": {
      label: "",
      eq: "3,={639_3_1_394}",
    },
    "639_1_500_2b": {
      label: "",
      eq: "3,=({639_1_65_25}+{639_1_66_2})",
    },
    "639_1_500_3b": {
      label: "",
      eq: "3,=(abs({639_3_1_388})+(abs({639_3_1_389})+(if(({639_1_66_2}+{639_1_500_2b})>1,1,0))))",
    },
    "639_3_400_10b": {
      label: "",
      eq: "3,={639_3_1_395}",
    },
    "639_3_400_11b": {
      label: "",
      eq: "3,={639_3_1_396}",
    },
    "639_3_500_4b": {
      label: "TOTAL POWER",
      eq: "3,=(if(abs({639_3_1_386})>0,2250,0)+(if(abs({639_3_1_387})>0,2250,0)))",
    },
    "639_3_500_5b": {
      label: "AVAILABLE POWER",
      eq: "3,=((if(abs({639_3_1_386})>0,2250,0)+(if(abs({639_3_1_387})>0,2250,0)))-((if(abs({639_3_1_386})>0,{639_3_1_376},0)+(if(abs({639_3_1_387})>0,{639_3_1_377},0)))))",
    },
    "639_3_500_6b": {
      label: "USED POWER",
      eq: "3,=(if(abs({639_3_1_392})>0,{639_3_1_300},0)+(if(abs({639_3_1_393})>0,{639_3_1_302},0)+(if(abs({639_3_1_394}+{639_1_65_25})>1,{639_3_1_299},0))))",
    },
    "639_3_500_7b": {
      label: "TOTAL POWER",
      eq: "3,=(if(abs({639_3_1_388})>0,2250,0)+(if(abs({639_3_1_389})>0,2250,0)))",
    },
    "639_3_500_8b": {
      label: "AVAILABLE POWER",
      eq: "3,=((if(abs({639_3_1_388})>0,2250,0)+(if(abs({639_3_1_389})>0,2250,0)))-((if(abs({639_3_1_388})>0,{639_3_1_378},0)+(if(abs({639_3_1_389})>0,{639_3_1_379},0)))))",
    },
    "639_3_500_9b": {
      label: "USED POWER",
      eq: "3,=(if(abs({639_3_1_395})>0,{639_3_1_301},0)+(if(abs({639_3_1_396})>0,{639_3_1_303},0)+(if(and(abs({639_1_66_2})=1,({639_1_65_25})=0,{639_3_1_394}=1),{639_3_1_299},0))))",
    },
    "639_3_800_1b": {
      label: "Number of Generators Online",
      eq: "3,=if({639_1_42_26}+{639_1_42_25}>1,1,0)+(if({639_1_44_21}+{639_1_44_20}>1,1,0)+(if({639_1_48_25}+{639_1_48_24}>1,1,0)+(if({639_1_46_29}+{639_1_46_28}>1,1,0))))",
    },
    "639_3_800_2b": {
      label: "main mode = dp and sub mode=relaxed",
      eq: '3,=(if(and({639_3_1_1}="dp",{639_3_1_2}="relaxed"),1,0))',
    },
    "639_3_800_3b": {
      label: "Number of thrusters online",
      eq: '3,=(((if({639_3_1_209}="in_use",1,0)+if({639_3_1_210}="in_use",1,0)+if({639_3_1_211}="in_use",1,0))))',
    },
    "639_3_800_4b": {
      label: "Number of Main Props online",
      eq: '3,=(if({639_3_1_212}="in_use",1,0)+if({639_3_1_213}="in_use",1,0))',
    },
    "639_3_800_5b": {
      label: "vessel in dp/relaxed and at least 1 thruster online",
      eq: "3,=(if(and({639_3_800_2b}=1,{639_3_800_3b}>0),1,0))",
    },
    "639_3_800_6b": {
      label: "Number of Position Reference Systems Enabled",
      eq: '3,=(((if({639_3_1_12}="sens_enabled",1,0)+if({639_3_1_13}="sens_enabled",1,0)+if({639_3_1_14}="sens_enabled",1,0)+if({639_3_1_15}="sens_enabled",1,0))))',
    },
    "639_3_800_7b": {
      label: "Number of Gyros Available",
      eq: '3,=((if({639_3_1_137}="sens_enabled",1,0)+if({639_3_1_138}="sens_enabled",1,0)+if({639_3_1_139}="sens_enabled",1,0)))',
    },
    "639_3_800_8b": {
      label: "Number of VRU s Available",
      eq: '3,=((if({639_3_1_162}="sens_enabled",1,0)+if({639_3_1_163}="sens_enabled",1,0)+if({639_3_1_164}="sens_enabled",1,0)))',
    },
    "639_3_800_9b": {
      label: "Number of Wind Sensors Available",
      eq: '3,=((if({639_3_1_177}="sens_enabled",1,0)+if({639_3_1_178}="sens_enabled",1,0)+if({639_3_1_179}="sens_enabled",1,0)))',
    },
    "639_3_900_1b": {
      label: "",
      eq: "3,=if({639_3_800_1b}>0,1,0)",
    },
    "639_3_900_2b": {
      label: "",
      eq: "3,=(if(and({639_3_800_3b}>0,{639_3_800_4b}>0),1,0))",
    },
    "639_3_900_3b": {
      label: "",
      eq: "3,=1",
    },
    "639_3_900_4b": {
      label: "",
      eq: "3,=if({639_3_800_7b}>1,1,0)",
    },
    "639_3_900_5b": {
      label: "",
      eq: "3,=if({639_3_800_8b}>1,1,0)",
    },
    "639_3_900_6b": {
      label: "",
      eq: "3,=if({639_3_800_9b}>1,1,0)",
    },
  },
};

export const HULL137DpStabilatorData = {
  data: {
    MainMode: "DPS|1",
    SubMode: "DPS|2",
    Heading: "DPS|8",
    WindDirection: "DPS|189",
    WindSpeed: "DPS|190",
    CurrentDirection: "DPS|191",
    CurrentSpeed: "DPS|192",
    Roll: "DPS|147",
    Pitch: "DPS|152",
    Heave: "DPS|157",
    SpeedAlong: "DPS|9",
    AftDraft: "IBS|393",
    FwdDraft: "IBS|391",
    Gen1: "IBS|982",
    Gen2: "IBS|1142",
    Gen3: "IBS|1293",
    Gen4: "IBS|1453",
  },
  tanks: [
    {
      dataSpec: "IBS|113",
      fluid: "freshwater",
      label: "ANTIROLL/CARGO F/W",
      maxRng: 188.09,
      numDecimalPlaces: 2,
      units: "m³",
      col: 12,
      row: 2,
      x: 1400,
      y: 450,
    },
    {
      dataSpec: "IBS|104",
      fluid: "freshwater",
      label: "CARGO F/W 2-S",
      maxRng: 29.63,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 225,
      y: 500,
    },
    {
      dataSpec: "IBS|105",
      fluid: "freshwater",
      label: "CARGO F/W 3-S",
      maxRng: 139.31,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 350,
      y: 500,
    },
    {
      dataSpec: "IBS|106",
      fluid: "freshwater",
      label: "CARGO F/W 4-S",
      maxRng: 95.39,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 475,
      y: 500,
    },
    {
      dataSpec: "IBS|107",
      fluid: "freshwater",
      label: "CARGO F/W 5-S",
      maxRng: 205.14,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 600,
      y: 500,
    },
    {
      dataSpec: "IBS|108",
      fluid: "freshwater",
      label: "CARGO F/W 7-S",
      maxRng: 240.04,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 725,
      y: 500,
    },
    {
      dataSpec: "IBS|109",
      fluid: "freshwater",
      label: "CARGO F/W 8-S",
      maxRng: 151.19,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 850,
      y: 500,
    },
    {
      dataSpec: "IBS|110",
      fluid: "balast",
      label: "Ballast/Cargo 9-S",
      maxRng: 148.21,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 975,
      y: 500,
    },
    {
      dataSpec: "IBS|111",
      fluid: "balast",
      label: "Ballast/Cargo 10-S",
      maxRng: 72.44,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 1100,
      y: 500,
    },
    {
      dataSpec: "IBS|112",
      fluid: "balast",
      label: "Ballast/Cargo 11-S",
      maxRng: 50.99,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 1225,
      y: 500,
    },
    {
      dataSpec: "IBS|78",
      fluid: "balast",
      label: "FOREPEAK TANK LEVEL",
      maxRng: 149.61,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      row: 2,
      col: 1,
      x: 0,
      y: 650,
    },
    {
      dataSpec: "IBS|79",
      fluid: "freshwater",
      label: "CARGO F/W 5-C",
      maxRng: 90.65,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 600,
      y: 650,
    },
    {
      dataSpec: "IBS|80",
      fluid: "freshwater",
      label: "CARGO F/W 7-C",
      maxRng: 99.5,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 725,
      y: 650,
    },
    {
      dataSpec: "IBS|93",
      fluid: "freshwater",
      label: "CARGO F/W 2-P",
      maxRng: 29.63,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 225,
      y: 800,
    },
    {
      dataSpec: "IBS|94",
      fluid: "freshwater",
      label: "CARGO F/W 3-P",
      maxRng: 139.31,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 350,
      y: 800,
    },
    {
      dataSpec: "IBS|95",
      fluid: "freshwater",
      label: "CARGO F/W 4-P",
      maxRng: 139.12,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 475,
      y: 800,
    },
    {
      dataSpec: "IBS|96",
      fluid: "freshwater",
      label: "CARGO F/W 5-P",
      maxRng: 205.14,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 600,
      y: 800,
    },
    {
      dataSpec: "IBS|97",
      fluid: "freshwater",
      label: "CARGO F/W 7-P",
      maxRng: 240.04,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 725,
      y: 800,
    },
    {
      dataSpec: "IBS|98",
      fluid: "balast",
      label: "Ballast/Cargo 10-P",
      maxRng: 72.57,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 1100,
      y: 800,
    },
    {
      dataSpec: "IBS|99",
      fluid: "balast",
      label: "AFT PEAK BALLAST/CARGO 11-P",
      maxRng: 50.99,
      numDecimalPlaces: 2,
      size: "104,160",
      units: "m³",
      x: 1225,
      y: 800,
    },
  ],
};

export const HULL288DpStabilatorData = {
  data: {
    MainMode: "DPS|1",
    SubMode: "DPS|2",
    Heading: "DPS|8",
    WindDirection: "DPS|189",
    WindSpeed: "DPS|190",
    CurrentDirection: "DPS|191",
    CurrentSpeed: "DPS|192",
    Roll: "DPS|147",
    Pitch: "DPS|152",
    Heave: "DPS|157",
    SpeedAlong: "DPS|9",
    AftDraft: "IBS|13971",
    FwdDraft: "IBS|13969",
    Gen1: "IBS|14564",
    Gen2: "IBS|14623",
    Gen3: "IBS|14695",
    Gen4: "IBS|14755",
  },
  tanks: [
    {
      dataSpec: "IBS|123",
      fluid: "freshwater",
      label: "ANTIROLL/CARGO F/W",
      location: "1500,450",
      loValue: 0,
      maxRng: 45791,
      numDecimalPlaces: 2,
      col: 12,
      row: 2,
      size: "250,250",
      units: "GAL",
    },
    {
      dataSpec: "IBS|103",
      fluid: "balast",
      label: "Ballast/Cargo 1-S",
      location: "100,500",
      loValue: 0,
      maxRng: 16603,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|105",
      fluid: "freshwater",
      label: "CARGO F/W 2-S",
      location: "225,500",
      loValue: 0,
      maxRng: 7828,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|107",
      fluid: "freshwater",
      label: "CARGO F/W 3-S",
      location: "350,500",
      loValue: 0,
      maxRng: 36802,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|109",
      fluid: "freshwater",
      label: "CARGO F/W 4-S",
      location: "475,500",
      loValue: 0,
      maxRng: 27010,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|111",
      fluid: "freshwater",
      label: "CARGO F/W 5-S",
      location: "600,500",
      loValue: 0,
      maxRng: 54631,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|113",
      fluid: "freshwater",
      label: "CARGO F/W 7-S",
      location: "725,500",
      loValue: 0,
      maxRng: 61771,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|115",
      fluid: "freshwater",
      label: "CARGO F/W 8-S",
      location: "850,500",
      loValue: 0,
      maxRng: 34628,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|117",
      fluid: "balast",
      label: "Ballast/Cargo 9-S",
      location: "975,500",
      loValue: 0,
      maxRng: 38486,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|119",
      fluid: "balast",
      label: "Ballast/Cargo 10-S",
      location: "1100,500",
      loValue: 0,
      maxRng: 22331,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|121",
      fluid: "balast",
      label: "Ballast/Cargo 11-S",
      location: "1225,500",
      loValue: 0,
      maxRng: 13470,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|61",
      fluid: "balast",
      label: "FOREPEAK TANK LEVEL",
      location: "0,650",
      loValue: 0,
      maxRng: 39307,
      row: 2,
      col: 1,
      numDecimalPlaces: 2,
      size: "175,120",
      units: "GAL",
    },
    {
      dataSpec: "IBS|63",
      fluid: "freshwater",
      label: "CARGO F/W 3-C",
      location: "350,650",
      loValue: 0,
      maxRng: 13218,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|65",
      fluid: "freshwater",
      label: "CARGO F/W 5-C",
      location: "600,650",
      loValue: 0,
      maxRng: 23948,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|67",
      fluid: "freshwater",
      label: "CARGO F/W 7-C",
      location: "725,650",
      loValue: 0,
      maxRng: 26282,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|79",
      fluid: "balast",
      label: "Ballast/Cargo 1-P",
      location: "100,800",
      loValue: 0,
      maxRng: 16603,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|81",
      fluid: "freshwater",
      label: "CARGO F/W 2-P",
      location: "225,800",
      loValue: 0,
      maxRng: 7828,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|83",
      fluid: "freshwater",
      label: "CARGO F/W 3-P",
      location: "350,800",
      loValue: 0,
      maxRng: 36802,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|85",
      fluid: "freshwater",
      label: "CARGO F/W 4-P",
      location: "475,800",
      loValue: 0,
      maxRng: 38564,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|87",
      fluid: "freshwater",
      label: "CARGO F/W 5-P",
      location: "600,800",
      loValue: 0,
      maxRng: 55600,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|89",
      fluid: "freshwater",
      label: "CARGO F/W 7-P",
      location: "725,800",
      loValue: 0,
      maxRng: 61771,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|91",
      fluid: "freshwater",
      label: "CARGO F/W 8-P",
      location: "850,800",
      loValue: 0,
      maxRng: 34628,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|93",
      fluid: "balast",
      label: "Ballast/Cargo 9-P",
      location: "975,800",
      loValue: 0,
      maxRng: 39883,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|95",
      fluid: "balast",
      label: "Ballast/Cargo 10-P",
      location: "1100,800",
      loValue: 0,
      maxRng: 23028,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
    {
      dataSpec: "IBS|97",
      fluid: "balast",
      label: "AFT PEAK BALLAST/CARGO 11-P",
      location: "1225,800",
      loValue: 0,
      maxRng: 13470,
      numDecimalPlaces: 2,
      size: "175,100",
      units: "GAL",
    },
  ],
};

export const groupByOptions: IMtDropdownData[] = [
  // {
  //   name: "Date",
  //   value: "date",
  // },
  {
    name: "Alarm",
    value: "alarm",
  },
  {
    name: "Ack'ed",
    value: "acked",
  },
  {
    name: "A-Z",
    value: "az",
  },
  // {
  //   name: "Location",
  //   value: "location",
  // },
  {
    name: "Follow",
    value: "follow",
  },
  // {
  //   name: "Custom",
  //   value: "custom",
  // },
];

export const cctvSortByOptions: IMtDropdownData[] = [
  {
    name: "Online First: A-Z",
    value: "online-a-to-z",
  },
  {
    name: "Online First: Z-A",
    value: "online-z-to-a",
  },
  {
    name: "A-Z",
    value: "a-to-z",
  },
  {
    name: "Z-A",
    value: "z-to-a",
  },
];

export const systemDropdownData: IMtDropdownData[] = [
  { name: "Air Compressor System	Air Compressor Unit", value: "s1" },
  { name: "Auxiliary Diesel Engine	Battery Charger", value: "s2" },
  { name: "Auxiliary Generator	Battery Room", value: "s3" },
  { name: "Bow Tunnel Thruster Set	Deck 1 / Electronic Room", value: "s4" },
  { name: "Cooling Support System	Deck 3 / AFT Eletronic Room", value: "s5" },
  { name: "Diesel Engine	Deck 3 / FWD Electronic Room", value: "s6" },
  {
    name: "Drop Down Thruster System	Diesel Engine Fuel Oil Cooling Pump 1",
    value: "s7",
  },
  {
    name: "Fuel Oil Day Tank	Diesel Engine Fuel Oil Cooling Pump 2",
    value: "s8",
  },
  { name: "Fuel Oil Support System	E-Gen Room", value: "s9" },
  { name: "Low Voltage AC	Electrical Motor", value: "s10" },
  { name: "Main Diesel Engine	Engine Control Room", value: "s11" },
  { name: "Reduction Gear	Engine Room", value: "s12" },
  { name: "Shaft Bearings	Engine Unit", value: "s13" },
  { name: "Stern Tunnel Thruster Set	Gearbox Unit", value: "s14" },
  { name: "Swing Down Thruster System	Generator Unit", value: "s15" },
];

export const equipmentDropdownData: IMtDropdownData[] = [
  { name: "Heat Exchanger", value: "e1" },
  { name: "Heat Exchanger - AFT Cooler", value: "e2" },
  { name: "Heat Exchanger - Fuel Oil Plate", value: "e3" },
  { name: "Heat Exchanger - GenSet Gridcooler", value: "e4" },
  { name: "Heat Exchanger - Gridcooler", value: "e5" },
  { name: "Heat Exchanger - Jacket Water", value: "e6" },
  { name: "Heat Exchanger - VFD Channel Cooler", value: "e7" },
  { name: "Heat Exchanger- VFD Cooler", value: "e8" },
  { name: "Intermediate Shaft Bearing", value: "e9" },
  { name: "Lowe Deck", value: "e10" },
  { name: "Lower Deck Stairway", value: "e11" },
  { name: "Lub Oil Pump", value: "e12" },
  { name: "Lub Oil Pump #1", value: "e13" },
  { name: "Lub Oil Pump #2", value: "e14" },
  { name: "Main Deck Locker", value: "e15" },
  { name: "N/A", value: "e16" },
  { name: "Port Switchboard / VFD Room", value: "e17" },
  { name: "PORT Z-DRIVE Heat Exchanger", value: "e18" },
  { name: "PORT Z-DRIVE THRUSTER LUBE OIL CHANNEL COOLER", value: "e19" },
  { name: "PORT Z-DRIVE/MAIN PROPULSION VFD CHANNEL COOLER", value: "e20" },
  { name: "Propulsion Room", value: "e21" },
  { name: "Pump Unit", value: "e22" },
  { name: "Pump Unit - AFT Cooler", value: "e23" },
  { name: "Pump Unit Cooling Water Pump 1", value: "e24" },
  { name: "Pump Unit Cooling Water Pump 2", value: "e25" },
  { name: "Pump Unit Fuel Oil Cooling Water Pump A1", value: "e26" },
  { name: "Pump Unit Fuel Oil Cooling Water Pump A2", value: "e27" },
  {
    name: "Pump Unit FWD. TUNNEL THRUSTER ELECTRIC MOTOR COOLING WATER PUMP A1",
    value: "e28",
  },
  {
    name: "Pump Unit FWD. TUNNEL THRUSTER ELECTRIC MOTOR COOLING WATER PUMP A2",
    value: "e29",
  },
  { name: "Pump Unit Genset Cooling Water Pump A1", value: "e30" },
  { name: "Pump Unit Genset Cooling Water Pump A2", value: "e31" },
  { name: "Pump Unit- Jacket Water", value: "e32" },
  {
    name: "Pump Unit PORT MAIN ENGINE GEAR BOX, SHAFT GEN. & AFT T.T ELECTRIC MOTOR COOLING WATER PUMP A1",
    value: "e33",
  },
  {
    name: "Pump Unit PORT MAIN ENGINE GEAR BOX, SHAFT GEN. & AFT T.T ELECTRIC MOTOR COOLING WATER PUMP A2",
    value: "e34",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 EL. MOTOR COOLING WATER PUMP N/A1",
    value: "e35",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 EL. MOTOR COOLING WATER PUMP N/A2",
    value: "e36",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 LUBE OIL COOLING WATER PUMP N/A1",
    value: "e37",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 LUBE OIL COOLING WATER PUMP N/A2",
    value: "e38",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 VFD COOLING WATER PUMP N/A1",
    value: "e39",
  },
  {
    name: "Pump Unit PORT Z-DRIVE THRUSTER N/A1 VFD COOLING WATER PUMP N/A2",
    value: "e40",
  },
  {
    name: "Pump Unit STBD MAIN ENGINE GEAR BOX & SHAFT GEN. COOLING WATER PUMP A1",
    value: "e41",
  },
  {
    name: "Pump Unit STBD MAIN ENGINE GEAR BOX & SHAFT GEN. COOLING WATER PUMP A2",
    value: "e42",
  },
  {
    name: "Pump Unit STBD Z-DRIVE N/A2 EL. MOTOR COOLING WATER PUMP N/A1",
    value: "e43",
  },
  {
    name: "Pump Unit STBD Z-DRIVE N/A2 EL. MOTOR COOLING WATER PUMP N/A1",
    value: "e44",
  },
  {
    name: "Pump Unit STBD Z-DRIVE THRUSTER N/A2 LUBE OIL COOLING WATER PUMP N/A1",
    value: "e45",
  },
  {
    name: "Pump Unit STBD Z-DRIVE THRUSTER N/A2 LUBE OIL COOLING WATER PUMP N/A2",
    value: "e46",
  },
  {
    name: "Pump Unit STBD Z-DRIVE THRUSTER N/A2 VFD COOLING WATER PUMP N/A1",
    value: "e47",
  },
  {
    name: "Pump Unit STBD Z-DRIVE THRUSTER N/A2 VFD COOLING WATER PUMP N/A2",
    value: "e48",
  },
  {
    name: "Pump Unit SWING DOWN COMBI THRUSTER HYD OIL COOOLING WATER PUMP A1",
    value: "e49",
  },
  {
    name: "Pump Unit SWING DOWN COMBI THRUSTER HYD OIL COOOLING WATER PUMP A2",
    value: "e50",
  },
  { name: "Pump Unit VFD Cooling Water Pump", value: "e51" },
  { name: "Shaft Bearing", value: "e52" },
  { name: "STBD Z-DRIVE Heat Exchanger", value: "e53" },
  { name: "STBD Z-DRIVE THRUSTER LUBE OIL CHANNEL COOLER", value: "e54" },
  { name: "STBD Z-DRIVE/MAIN PROPULSION VFD CHANNEL COOLER", value: "e55" },
  { name: "Stdb Switchboard / VFD Room", value: "e56" },
  { name: "Thruster Unit", value: "e57" },
  { name: "UPS Unit", value: "e58" },
];

export const ibsDataSetup: IChartElement[] = [
  {
    text: "Emergency Generator",
    layout: { x: 5, y: 5, w: 2, h: 1 },
    id: "emg-gen",
    type: "label",
  },
  {
    layout: { x: 4, y: 4, w: 1, h: 1 },
    icon: "mdi-electric-switch-closed",
    iconNegative: "mdi-electric-switch",
    id: "sw1",
    type: "switch",
  },
];

export const allResultObjects = [
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.56,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2822, 5452],
      linearRegression: {
        rSquared: 0.96,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.56,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2822, 5452],
      linearRegression: {
        rSquared: 0.96,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.23,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2901, 5952],
      linearRegression: {
        rSquared: 0.94,
      },
    },
  },
];
// Generate 20 mock data objects
const mockData = [];
for (let i = 0; i < 60; i++) {
  const dataObject = {
    dataPointY: [2365, 2368, 2363][Math.floor(i / 20)],
    dataPointC: 5435,
    standard: {
      dataPointsX: [Math.floor(Math.random() * 10000), Math.floor(Math.random() * 10000)],
      linearRegression: {
        rSquared: Math.random(),
      },
      linearRegressionSplit: {
        rSquared: Math.random(),
      },
    },
    family: {
      dataPointsX: [Math.floor(Math.random() * 10000), Math.floor(Math.random() * 10000)],
      linearRegression: {
        rSquared: Math.random(),
      },
    },
  };
  mockData.push(dataObject);
}

export const cobrasMockData = [...allResultObjects, ...mockData];

export const cobrasDemoData = [
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.56,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2822, 5452],
      linearRegression: {
        rSquared: 0.96,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.56,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2822, 5452],
      linearRegression: {
        rSquared: 0.96,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5435, 5468],
      linearRegression: {
        rSquared: 0.23,
      },
      linearRegressionSplit: {
        rSquared: 0.6,
      },
    },
    family: {
      dataPointsX: [2901, 5952],
      linearRegression: {
        rSquared: 0.94,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1325, 8804],
      linearRegression: {
        rSquared: 0.7903093149708564,
      },
      linearRegressionSplit: {
        rSquared: 0.12563038389527081,
      },
    },
    family: {
      dataPointsX: [5715, 4842],
      linearRegression: {
        rSquared: 0.28244634064443286,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6400, 2355],
      linearRegression: {
        rSquared: 0.7597270449061706,
      },
      linearRegressionSplit: {
        rSquared: 0.4713659913345878,
      },
    },
    family: {
      dataPointsX: [8411, 6849],
      linearRegression: {
        rSquared: 0.8611799052353442,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [2715, 4269],
      linearRegression: {
        rSquared: 0.9566564393124555,
      },
      linearRegressionSplit: {
        rSquared: 0.04805548018610439,
      },
    },
    family: {
      dataPointsX: [809, 2548],
      linearRegression: {
        rSquared: 0.84283417569579,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6831, 6397],
      linearRegression: {
        rSquared: 0.08751179067877013,
      },
      linearRegressionSplit: {
        rSquared: 0.7018054751886023,
      },
    },
    family: {
      dataPointsX: [5791, 4557],
      linearRegression: {
        rSquared: 0.9212316326950167,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1034, 1278],
      linearRegression: {
        rSquared: 0.03383269274375511,
      },
      linearRegressionSplit: {
        rSquared: 0.6270840804134739,
      },
    },
    family: {
      dataPointsX: [2623, 9782],
      linearRegression: {
        rSquared: 0.9060571634692547,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6263, 7238],
      linearRegression: {
        rSquared: 0.43403094542578047,
      },
      linearRegressionSplit: {
        rSquared: 0.39284797886109324,
      },
    },
    family: {
      dataPointsX: [8282, 6084],
      linearRegression: {
        rSquared: 0.09688798665171205,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4697, 859],
      linearRegression: {
        rSquared: 0.0591691000816128,
      },
      linearRegressionSplit: {
        rSquared: 0.6305119673255759,
      },
    },
    family: {
      dataPointsX: [3175, 9561],
      linearRegression: {
        rSquared: 0.08334728370492717,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [418, 7826],
      linearRegression: {
        rSquared: 0.21454607883048604,
      },
      linearRegressionSplit: {
        rSquared: 0.9980083712369425,
      },
    },
    family: {
      dataPointsX: [6072, 7082],
      linearRegression: {
        rSquared: 0.12566209495580094,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3654, 1728],
      linearRegression: {
        rSquared: 0.16382793726848877,
      },
      linearRegressionSplit: {
        rSquared: 0.907100192257368,
      },
    },
    family: {
      dataPointsX: [300, 1044],
      linearRegression: {
        rSquared: 0.7760228000094695,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4206, 4175],
      linearRegression: {
        rSquared: 0.40766160611153524,
      },
      linearRegressionSplit: {
        rSquared: 0.038083677653361514,
      },
    },
    family: {
      dataPointsX: [3915, 3388],
      linearRegression: {
        rSquared: 0.4933872580586445,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8650, 1068],
      linearRegression: {
        rSquared: 0.9192508670850388,
      },
      linearRegressionSplit: {
        rSquared: 0.6993904425827506,
      },
    },
    family: {
      dataPointsX: [9310, 8791],
      linearRegression: {
        rSquared: 0.23393788407908223,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5511, 6383],
      linearRegression: {
        rSquared: 0.4000680782252246,
      },
      linearRegressionSplit: {
        rSquared: 0.41656526161359486,
      },
    },
    family: {
      dataPointsX: [9218, 4195],
      linearRegression: {
        rSquared: 0.7285108840576286,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8581, 4275],
      linearRegression: {
        rSquared: 0.02277895206012248,
      },
      linearRegressionSplit: {
        rSquared: 0.08990722878000534,
      },
    },
    family: {
      dataPointsX: [6099, 4204],
      linearRegression: {
        rSquared: 0.46495825076185326,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3162, 5470],
      linearRegression: {
        rSquared: 0.3017290317253063,
      },
      linearRegressionSplit: {
        rSquared: 0.01869079749415503,
      },
    },
    family: {
      dataPointsX: [4963, 4539],
      linearRegression: {
        rSquared: 0.8843272818989485,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [2690, 7405],
      linearRegression: {
        rSquared: 0.8264080485110503,
      },
      linearRegressionSplit: {
        rSquared: 0.48109973464472544,
      },
    },
    family: {
      dataPointsX: [3084, 7789],
      linearRegression: {
        rSquared: 0.6538344840375923,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1522, 1936],
      linearRegression: {
        rSquared: 0.4774781974726532,
      },
      linearRegressionSplit: {
        rSquared: 0.7650843302015415,
      },
    },
    family: {
      dataPointsX: [5010, 9413],
      linearRegression: {
        rSquared: 0.9607901001821977,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [2617, 7751],
      linearRegression: {
        rSquared: 0.8732040351706185,
      },
      linearRegressionSplit: {
        rSquared: 0.5938783296968464,
      },
    },
    family: {
      dataPointsX: [2314, 1116],
      linearRegression: {
        rSquared: 0.24204016948682994,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3548, 3430],
      linearRegression: {
        rSquared: 0.772026155461671,
      },
      linearRegressionSplit: {
        rSquared: 0.9894702952504,
      },
    },
    family: {
      dataPointsX: [2754, 6702],
      linearRegression: {
        rSquared: 0.9992888147406165,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4427, 2842],
      linearRegression: {
        rSquared: 0.3428210533811049,
      },
      linearRegressionSplit: {
        rSquared: 0.8973776077599722,
      },
    },
    family: {
      dataPointsX: [4352, 2044],
      linearRegression: {
        rSquared: 0.8464421646445452,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 1 Cyl. 1",
    dataPointY: 2365,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9121, 29],
      linearRegression: {
        rSquared: 0.2770366294625686,
      },
      linearRegressionSplit: {
        rSquared: 0.6787265445635307,
      },
    },
    family: {
      dataPointsX: [7695, 6751],
      linearRegression: {
        rSquared: 0.5641107529852496,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4439, 6835],
      linearRegression: {
        rSquared: 0.33665830338627645,
      },
      linearRegressionSplit: {
        rSquared: 0.43904894995187416,
      },
    },
    family: {
      dataPointsX: [9212, 1732],
      linearRegression: {
        rSquared: 0.43541486978519406,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5429, 3423],
      linearRegression: {
        rSquared: 0.8313345953519071,
      },
      linearRegressionSplit: {
        rSquared: 0.7529691773041269,
      },
    },
    family: {
      dataPointsX: [7426, 6537],
      linearRegression: {
        rSquared: 0.6209263241342695,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5383, 8914],
      linearRegression: {
        rSquared: 0.823926060951004,
      },
      linearRegressionSplit: {
        rSquared: 0.17686868999000138,
      },
    },
    family: {
      dataPointsX: [3918, 7697],
      linearRegression: {
        rSquared: 0.456290106079813,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [7482, 5170],
      linearRegression: {
        rSquared: 0.6654642306035499,
      },
      linearRegressionSplit: {
        rSquared: 0.27979331167914445,
      },
    },
    family: {
      dataPointsX: [4884, 5773],
      linearRegression: {
        rSquared: 0.05195306406132927,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6612, 9905],
      linearRegression: {
        rSquared: 0.010613124082369474,
      },
      linearRegressionSplit: {
        rSquared: 0.7505131061237473,
      },
    },
    family: {
      dataPointsX: [7757, 9919],
      linearRegression: {
        rSquared: 0.08738126475795238,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6935, 165],
      linearRegression: {
        rSquared: 0.7746816221165302,
      },
      linearRegressionSplit: {
        rSquared: 0.2350831023691693,
      },
    },
    family: {
      dataPointsX: [6716, 6792],
      linearRegression: {
        rSquared: 0.840692617531007,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3454, 3476],
      linearRegression: {
        rSquared: 0.36832468154646136,
      },
      linearRegressionSplit: {
        rSquared: 0.9432463607784576,
      },
    },
    family: {
      dataPointsX: [1130, 4908],
      linearRegression: {
        rSquared: 0.8024191465876216,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8254, 8737],
      linearRegression: {
        rSquared: 0.34163526985059334,
      },
      linearRegressionSplit: {
        rSquared: 0.45428097088733055,
      },
    },
    family: {
      dataPointsX: [1662, 7372],
      linearRegression: {
        rSquared: 0.2534103202404854,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1009, 1644],
      linearRegression: {
        rSquared: 0.678350641579456,
      },
      linearRegressionSplit: {
        rSquared: 0.3208044569836339,
      },
    },
    family: {
      dataPointsX: [3410, 8450],
      linearRegression: {
        rSquared: 0.09242577510301264,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8947, 8828],
      linearRegression: {
        rSquared: 0.5125916619855015,
      },
      linearRegressionSplit: {
        rSquared: 0.12180370002985375,
      },
    },
    family: {
      dataPointsX: [8297, 4009],
      linearRegression: {
        rSquared: 0.9235430204447257,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5290, 5123],
      linearRegression: {
        rSquared: 0.14636875746861855,
      },
      linearRegressionSplit: {
        rSquared: 0.9497971932676854,
      },
    },
    family: {
      dataPointsX: [2384, 5524],
      linearRegression: {
        rSquared: 0.9787292829400926,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5896, 7829],
      linearRegression: {
        rSquared: 0.4693631113775161,
      },
      linearRegressionSplit: {
        rSquared: 0.9233057927431185,
      },
    },
    family: {
      dataPointsX: [1688, 3002],
      linearRegression: {
        rSquared: 0.9828599227994537,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8850, 7892],
      linearRegression: {
        rSquared: 0.1584535837438028,
      },
      linearRegressionSplit: {
        rSquared: 0.6589650261156694,
      },
    },
    family: {
      dataPointsX: [4225, 2285],
      linearRegression: {
        rSquared: 0.7919907104617767,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5625, 5611],
      linearRegression: {
        rSquared: 0.014505876274360396,
      },
      linearRegressionSplit: {
        rSquared: 0.5635385645302877,
      },
    },
    family: {
      dataPointsX: [2617, 9838],
      linearRegression: {
        rSquared: 0.7009867477759519,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9590, 1762],
      linearRegression: {
        rSquared: 0.7207233161398476,
      },
      linearRegressionSplit: {
        rSquared: 0.09936565757484983,
      },
    },
    family: {
      dataPointsX: [7782, 1708],
      linearRegression: {
        rSquared: 0.5316687098757713,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8633, 894],
      linearRegression: {
        rSquared: 0.08661077814399354,
      },
      linearRegressionSplit: {
        rSquared: 0.550767367794295,
      },
    },
    family: {
      dataPointsX: [392, 8396],
      linearRegression: {
        rSquared: 0.8378750134761208,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [504, 2831],
      linearRegression: {
        rSquared: 0.2386610068891879,
      },
      linearRegressionSplit: {
        rSquared: 0.903950043977668,
      },
    },
    family: {
      dataPointsX: [6748, 7739],
      linearRegression: {
        rSquared: 0.9292181166841667,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5613, 5379],
      linearRegression: {
        rSquared: 0.40811770338181486,
      },
      linearRegressionSplit: {
        rSquared: 0.4482286663021058,
      },
    },
    family: {
      dataPointsX: [8216, 5975],
      linearRegression: {
        rSquared: 0.430680292147932,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9700, 1199],
      linearRegression: {
        rSquared: 0.2512942136682823,
      },
      linearRegressionSplit: {
        rSquared: 0.5580330864698666,
      },
    },
    family: {
      dataPointsX: [9352, 8144],
      linearRegression: {
        rSquared: 0.9786029781277776,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 3",
    dataPointY: 2368,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4061, 188],
      linearRegression: {
        rSquared: 0.37742340737404034,
      },
      linearRegressionSplit: {
        rSquared: 0.8320557704665561,
      },
    },
    family: {
      dataPointsX: [115, 9367],
      linearRegression: {
        rSquared: 0.6978402583026408,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3261, 7265],
      linearRegression: {
        rSquared: 0.7556011881355826,
      },
      linearRegressionSplit: {
        rSquared: 0.01988464478242502,
      },
    },
    family: {
      dataPointsX: [7999, 769],
      linearRegression: {
        rSquared: 0.33426005156311356,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4449, 6894],
      linearRegression: {
        rSquared: 0.059080935337762375,
      },
      linearRegressionSplit: {
        rSquared: 0.2410544766315894,
      },
    },
    family: {
      dataPointsX: [3866, 1350],
      linearRegression: {
        rSquared: 0.26403999512827436,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [529, 5392],
      linearRegression: {
        rSquared: 0.36557672642423,
      },
      linearRegressionSplit: {
        rSquared: 0.5942507161391821,
      },
    },
    family: {
      dataPointsX: [8745, 4353],
      linearRegression: {
        rSquared: 0.8643538271192803,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9947, 2083],
      linearRegression: {
        rSquared: 0.5474597550142433,
      },
      linearRegressionSplit: {
        rSquared: 0.6149947810948251,
      },
    },
    family: {
      dataPointsX: [3162, 312],
      linearRegression: {
        rSquared: 0.22296147135871314,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [3077, 4057],
      linearRegression: {
        rSquared: 0.7193209608998601,
      },
      linearRegressionSplit: {
        rSquared: 0.3047875845779653,
      },
    },
    family: {
      dataPointsX: [6917, 8567],
      linearRegression: {
        rSquared: 0.4408435945483822,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [2221, 9385],
      linearRegression: {
        rSquared: 0.13107813592114503,
      },
      linearRegressionSplit: {
        rSquared: 0.7132195764619038,
      },
    },
    family: {
      dataPointsX: [3814, 8120],
      linearRegression: {
        rSquared: 0.4616646582419539,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6811, 4579],
      linearRegression: {
        rSquared: 0.31887275491932465,
      },
      linearRegressionSplit: {
        rSquared: 0.13051486292296555,
      },
    },
    family: {
      dataPointsX: [6632, 3821],
      linearRegression: {
        rSquared: 0.2663292345590762,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [50, 2555],
      linearRegression: {
        rSquared: 0.2081455539086694,
      },
      linearRegressionSplit: {
        rSquared: 0.43537796815778607,
      },
    },
    family: {
      dataPointsX: [2971, 5226],
      linearRegression: {
        rSquared: 0.3760255172846667,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [6030, 9078],
      linearRegression: {
        rSquared: 0.6725454172695624,
      },
      linearRegressionSplit: {
        rSquared: 0.4301992852134031,
      },
    },
    family: {
      dataPointsX: [726, 4261],
      linearRegression: {
        rSquared: 0.11339525996155397,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [8394, 5483],
      linearRegression: {
        rSquared: 0.17051451705720133,
      },
      linearRegressionSplit: {
        rSquared: 0.8885739169715878,
      },
    },
    family: {
      dataPointsX: [7136, 1285],
      linearRegression: {
        rSquared: 0.6529323093109647,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [4052, 2039],
      linearRegression: {
        rSquared: 0.557366116603748,
      },
      linearRegressionSplit: {
        rSquared: 0.08811016943524219,
      },
    },
    family: {
      dataPointsX: [1693, 5266],
      linearRegression: {
        rSquared: 0.9745893873959399,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1109, 4635],
      linearRegression: {
        rSquared: 0.24834541480253014,
      },
      linearRegressionSplit: {
        rSquared: 0.6611165851415055,
      },
    },
    family: {
      dataPointsX: [8539, 7639],
      linearRegression: {
        rSquared: 0.7204992330569269,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [1214, 5148],
      linearRegression: {
        rSquared: 0.8514589393231393,
      },
      linearRegressionSplit: {
        rSquared: 0.08057955586734122,
      },
    },
    family: {
      dataPointsX: [674, 6805],
      linearRegression: {
        rSquared: 0.7338131687937266,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [772, 8216],
      linearRegression: {
        rSquared: 0.5558592452794258,
      },
      linearRegressionSplit: {
        rSquared: 0.2631437924107478,
      },
    },
    family: {
      dataPointsX: [7601, 2701],
      linearRegression: {
        rSquared: 0.693797136742917,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [2000, 3398],
      linearRegression: {
        rSquared: 0.8313222755153993,
      },
      linearRegressionSplit: {
        rSquared: 0.27818103264191807,
      },
    },
    family: {
      dataPointsX: [383, 5008],
      linearRegression: {
        rSquared: 0.5476866987361975,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9817, 2980],
      linearRegression: {
        rSquared: 0.32023834012389174,
      },
      linearRegressionSplit: {
        rSquared: 0.8919452400296599,
      },
    },
    family: {
      dataPointsX: [995, 1629],
      linearRegression: {
        rSquared: 0.6355833497232888,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [7840, 5650],
      linearRegression: {
        rSquared: 0.6706108989842272,
      },
      linearRegressionSplit: {
        rSquared: 0.8979544485498678,
      },
    },
    family: {
      dataPointsX: [3915, 627],
      linearRegression: {
        rSquared: 0.687246067379397,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [430, 9128],
      linearRegression: {
        rSquared: 0.04140793167923995,
      },
      linearRegressionSplit: {
        rSquared: 0.9334557121002032,
      },
    },
    family: {
      dataPointsX: [4851, 7138],
      linearRegression: {
        rSquared: 0.5652220669465364,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [9761, 1175],
      linearRegression: {
        rSquared: 0.6154834602007664,
      },
      linearRegressionSplit: {
        rSquared: 0.16429169920505626,
      },
    },
    family: {
      dataPointsX: [9482, 73],
      linearRegression: {
        rSquared: 0.07454882572097721,
      },
    },
  },
  {
    subgroupName: "Diesel Eng. 2 Cyl. 1",
    dataPointY: 2363,
    dataPointC: 5435,
    standard: {
      dataPointsX: [5646, 879],
      linearRegression: {
        rSquared: 0.3313604383144091,
      },
      linearRegressionSplit: {
        rSquared: 0.0030950618016105658,
      },
    },
    family: {
      dataPointsX: [5535, 8800],
      linearRegression: {
        rSquared: 0.7146248640676063,
      },
    },
  },
];

const st = spacetime.now();
const start = st.format("{numeric-us} {time}");
const end = st.subtract(2, "day").format("{numeric-us} {time}");

export const datapointsNames: any = {
  1009: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  1034: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  1044: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  1068: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  1109: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  1116: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  1130: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  115: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  1175: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  1199: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  1214: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  1278: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  1285: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  1325: {
    name: "System current",
    start,
    end,
    type: null,
  },
  1350: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  1522: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  1629: {
    name: "System load",
    start,
    end,
    type: null,
  },
  1644: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  165: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  1662: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  1688: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  1693: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  1708: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  1728: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  1732: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  1762: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  188: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  1936: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  2000: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  2039: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  2044: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  2083: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  2221: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  2285: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  2314: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  2355: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  2363: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  2365: {
    name: "System current",
    start,
    end,
    type: null,
  },
  2368: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  2384: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  2548: {
    name: "System load",
    start,
    end,
    type: null,
  },
  2555: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  2617: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  2623: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  2690: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  2701: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  2715: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  2754: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  2822: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  2831: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  2842: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  2901: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  2971: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  2980: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  300: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  3002: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  3077: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  3084: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  312: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  3162: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  3175: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  3261: {
    name: "System current",
    start,
    end,
    type: null,
  },
  3388: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  3398: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  3410: {
    name: "System load",
    start,
    end,
    type: null,
  },
  3423: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  3430: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  3454: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  3476: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  3548: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  3654: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  3814: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  3821: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  383: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  3866: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  3915: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  3918: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  392: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  4009: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  4052: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  4057: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  4061: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  4175: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  418: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  4195: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  4204: {
    name: "System current",
    start,
    end,
    type: null,
  },
  4206: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  4225: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  4261: {
    name: "System load",
    start,
    end,
    type: null,
  },
  4269: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  4275: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  430: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  4352: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  4353: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  4427: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  4439: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  4449: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  4539: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  4557: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  4579: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  4635: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  4697: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  4842: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  4851: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  4884: {
    name: "Fluid flow rate",
    start,
    end,
    type: "Low",
  },
  4908: {
    name: "Fluid temperature",
    start,
    end,
    type: "Low",
  },
  4963: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  5008: {
    name: "Fluid level",
    start,
    end,
    type: "High",
  },
  5010: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  504: {
    name: "System current",
    start,
    end,
    type: "Low",
  },
  5123: {
    name: "System frequency",
    start,
    end,
    type: "Low",
  },
  5148: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  5170: {
    name: "System load",
    start,
    end,
    type: null,
  },
  5226: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  5266: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  529: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  5290: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  5379: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  5383: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  5392: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  5429: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  5435: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  5452: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  5468: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  5470: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  5483: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  5511: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  5524: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  5535: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  5611: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  5613: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  5625: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  5646: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  5650: {
    name: "System current",
    start,
    end,
    type: null,
  },
  5715: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  5773: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  5791: {
    name: "System load",
    start,
    end,
    type: null,
  },
  5896: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  5952: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  5975: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  6030: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  6072: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  6084: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  6099: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  6263: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  627: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  6383: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  6397: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  6400: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  6537: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  6612: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  6632: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  6702: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  6716: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  674: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  6748: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  6751: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  6792: {
    name: "System current",
    start,
    end,
    type: null,
  },
  6805: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  6811: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  6831: {
    name: "System load",
    start,
    end,
    type: null,
  },
  6835: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  6849: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  6894: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  6917: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  6935: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  7082: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  7136: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  7138: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  7238: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  726: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  7265: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  7372: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  7405: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  7426: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  7482: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  7601: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  7639: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  769: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  7695: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  7697: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  772: {
    name: "System current",
    start,
    end,
    type: null,
  },
  7739: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  7751: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  7757: {
    name: "System load",
    start,
    end,
    type: null,
  },
  7782: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  7789: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  7826: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  7829: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  7840: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  7892: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  7999: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  809: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  8120: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  8144: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  8216: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  8254: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  8282: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  8297: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  8394: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  8396: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  8411: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  8450: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  8539: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  8567: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  8581: {
    name: "System current",
    start,
    end,
    type: null,
  },
  859: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  8633: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  8650: {
    name: "System load",
    start,
    end,
    type: null,
  },
  8737: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  8745: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  879: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  8791: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  8800: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  8804: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  8828: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  8850: {
    name: "Ambient temperature",
    start,
    end,
    type: null,
  },
  8914: {
    name: "Ambient pressure",
    start,
    end,
    type: null,
  },
  894: {
    name: "Ambient humidity",
    start,
    end,
    type: null,
  },
  8947: {
    name: "Equipment vibration",
    start,
    end,
    type: null,
  },
  9078: {
    name: "Equipment temperature",
    start,
    end,
    type: null,
  },
  9121: {
    name: "Equipment pressure",
    start,
    end,
    type: null,
  },
  9128: {
    name: "Equipment power consumption",
    start,
    end,
    type: null,
  },
  9212: {
    name: "Equipment speed",
    start,
    end,
    type: null,
  },
  9218: {
    name: "Fluid flow rate",
    start,
    end,
    type: null,
  },
  9310: {
    name: "Fluid temperature",
    start,
    end,
    type: null,
  },
  9352: {
    name: "Fluid pressure",
    start,
    end,
    type: null,
  },
  9367: {
    name: "Fluid level",
    start,
    end,
    type: null,
  },
  9385: {
    name: "System voltage",
    start,
    end,
    type: null,
  },
  9413: {
    name: "System current",
    start,
    end,
    type: null,
  },
  9482: {
    name: "System frequency",
    start,
    end,
    type: null,
  },
  9561: {
    name: "System efficiency",
    start,
    end,
    type: null,
  },
  9590: {
    name: "System load",
    start,
    end,
    type: null,
  },
  9700: {
    name: "System temperature",
    start,
    end,
    type: null,
  },
  9761: {
    name: "System pressure",
    start,
    end,
    type: null,
  },
  9782: {
    name: "System humidity",
    start,
    end,
    type: null,
  },
  9817: {
    name: "Component temperature",
    start,
    end,
    type: null,
  },
  9838: {
    name: "Component pressure",
    start,
    end,
    type: null,
  },
  9905: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  9919: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
  9947: {
    name: "Component vibration",
    start,
    end,
    type: null,
  },
  995: {
    name: "Component health status",
    start,
    end,
    type: null,
  },
};

export const weatherForecastChecklist: ICheckListData[] = [
  {
    name: "Wind Conditions",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Wind speed forecast is under 44 knots",
        isChecked: false,
      },
      {
        id: "2",
        label: "No gusting wind conditions expected",
        isChecked: false,
      },
    ],
  },
  {
    name: "Wave and Sea State",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "Significant wave height (Hs) is 2.5m or less",
        isChecked: false,
      },
      {
        id: "4",
        label: "Maximum wave height (Hmax) is 4m or less",
        isChecked: false,
      },
      {
        id: "5",
        label: "Sea state conditions are not expected to deteriorate within operation timeframe",
        isChecked: false,
      },
    ],
  },
  {
    name: "Visibility and Precipitation",
    isChecked: false,
    list: [
      {
        id: "6",
        label: "Visibility forecast is within safe operational limits",
        isChecked: false,
      },
      {
        id: "7",
        label: "No heavy rainfall or precipitation events expected",
        isChecked: false,
      },
    ],
  },
  {
    name: "General Safety Indicators",
    isChecked: false,
    list: [
      {
        id: "8",
        label: "No severe weather warnings (e.g. gales, thunderstorms) in operational area",
        isChecked: false,
      },
      {
        id: "9",
        label: "Barometric pressure trend is stable or improving",
        isChecked: false,
      },
      {
        id: "10",
        label: "Forecast period covers the entire expected operation window",
        isChecked: false,
      },
    ],
  },
];

export const prevailingWeatherForceChecklist: ICheckListData[] = [
  {
    name: "Wind and Current Direction",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Wind is not directed towards the offshore asset (preferred)",
        isChecked: false,
      },
      {
        id: "2",
        label: "Current direction is stable and not aligned toward the asset",
        isChecked: false,
      },
    ],
  },
  {
    name: "Risk Assessment and Mitigation",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "If wind/current is towards asset, risk assessment is conducted and approved",
        isChecked: false,
      },
      {
        id: "4",
        label: "Mitigation measures (e.g. increased monitoring, standby tugs) are in place",
        isChecked: false,
      },
    ],
  },
  {
    name: "Operational Awareness",
    isChecked: false,
    list: [
      {
        id: "5",
        label: "Bridge and deck crews are informed of prevailing weather force direction",
        isChecked: false,
      },
      {
        id: "6",
        label: "DP Operator is actively monitoring for any unplanned drift",
        isChecked: false,
      },
    ],
  },
];

export const driveOffDriftOffChecklist: ICheckListData[] = [
  {
    name: "Thruster Behavior and DP System",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "All thruster performance is within expected loading profiles",
        isChecked: false,
      },
      {
        id: "2",
        label: "No unexplained ramp-up of thrusters observed",
        isChecked: false,
      },
      {
        id: "3",
        label: "DP system diagnostics are normal and within tolerance",
        isChecked: false,
      },
    ],
  },
  {
    name: "Position Reference Systems (PRS)",
    isChecked: false,
    list: [
      {
        id: "4",
        label: "No discrepancies noted in PRS (e.g. radar, DGPS, hydroacoustic)",
        isChecked: false,
      },
      {
        id: "5",
        label: "Redundant PRS systems are active and operational",
        isChecked: false,
      },
    ],
  },
  {
    name: "Operator Response and Emergency Protocols",
    isChecked: false,
    list: [
      {
        id: "6",
        label: "DPO immediately reacts if drift off or drive off is detected",
        isChecked: false,
      },
      {
        id: "7",
        label: "Drive-off / drift-off drills have been conducted within last 30 days",
        isChecked: false,
      },
      {
        id: "8",
        label: "Vessel can be brought under control in simulated scenarios",
        isChecked: false,
      },
    ],
  },
];

export const gangwayEnvLimitChecklist: ICheckListData[] = [
  {
    name: "W2W Gangway Environmental Check",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Wave height, wind speed, and vessel motion within CAMO gangway limits",
        isChecked: false,
      },
      {
        id: "2",
        label: "Gangway sensors and active compensation are functioning correctly",
        isChecked: false,
      },
      {
        id: "3",
        label: "No alarms or limit warnings from gangway system",
        isChecked: false,
      },
      {
        id: "4",
        label: "Manual override procedures are reviewed and ready if needed",
        isChecked: false,
      },
      {
        id: "5",
        label: "Personnel briefed on gangway emergency disconnect and safety zones",
        isChecked: false,
      },
    ],
  },
];

export const draftChecklist: ICheckListData[] = [
  {
    name: "Propeller Draft Status",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Propellers remain below surface (no aeration)",
        isChecked: false,
      },
      {
        id: "2",
        label: "No indication of prop surfacing or ventilation under load",
        isChecked: false,
      },
      {
        id: "3",
        label: "Station keeping is unaffected by draft or prop aeration",
        isChecked: false,
      },
    ],
  },
];

export const closestApproachChecklist: ICheckListData[] = [
  {
    name: "Separation Distance",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "More than 10m separation is maintained at all times",
        isChecked: false,
      },
      {
        id: "2",
        label: "DP system is actively monitoring approach zones",
        isChecked: false,
      },
      {
        id: "3",
        label: "MOC in place if operations require <10m separation",
        isChecked: false,
      },
    ],
  },
];

export const auxUPSChecklist: ICheckListData[] = [
  {
    name: "Auxiliary UPS Supply",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "No UPS units in bypass mode",
        isChecked: false,
      },
      {
        id: "2",
        label: "No alarms on any UPS",
        isChecked: false,
      },
      {
        id: "3",
        label: "UPS batteries fully charged and healthy",
        isChecked: false,
      },
    ],
  },
];

export const thrusterGen24VdcChecklist: ICheckListData[] = [
  {
    name: "24Vdc Supply for Thrusters & Generators",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Charger supply available to all systems",
        isChecked: false,
      },
      {
        id: "2",
        label: "No charger alarms active",
        isChecked: false,
      },
      {
        id: "3",
        label: "No system is running on battery alone",
        isChecked: false,
      },
    ],
  },
];

export const dpVentilationChecklist: ICheckListData[] = [
  {
    name: "DP Critical Ventilation",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "All supply and exhaust fans operating in critical spaces",
        isChecked: false,
      },
      {
        id: "2",
        label: "No alarms or performance reductions observed",
        isChecked: false,
      },
    ],
  },
];

export const airConditioningChecklist: ICheckListData[] = [
  {
    name: "Air Conditioning in DP Critical Areas",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Air conditioning functioning normally in all required zones",
        isChecked: false,
      },
      {
        id: "2",
        label: "No signs of performance degradation or shutdown",
        isChecked: false,
      },
    ],
  },
];
export const compressedAirChecklist: ICheckListData[] = [
  {
    name: "Compressed Air System",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "System operating normally with no alarms",
        isChecked: false,
      },
      {
        id: "2",
        label: "No start or control air losses recorded",
        isChecked: false,
      },
    ],
  },
];

export const essentialCommsChecklist: ICheckListData[] = [
  {
    name: "Essential Communication Systems",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "All communication lines (Bridge, Engine Room, Deck, Surface Facility) are online",
        isChecked: false,
      },
      {
        id: "2",
        label: "Redundant systems in place and functioning",
        isChecked: false,
      },
      {
        id: "3",
        label: "Only one comms system remaining triggers immediate alert",
        isChecked: false,
      },
    ],
  },
];
export const dpConsequenceAnalysisChecklist: ICheckListData[] = [
  {
    name: "DP Consequence Analysis",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "DP2 Mode is active and verified",
        isChecked: false,
      },
      {
        id: "2",
        label: "No active warnings present in the consequence analysis",
        isChecked: false,
      },
    ],
  },
];

export const dpThrusterControllersChecklist: ICheckListData[] = [
  {
    name: "Controller Availability",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "All thruster controllers are reported available and online",
        isChecked: false,
      },
      {
        id: "2",
        label: "No loss of any controller hardware or channel",
        isChecked: false,
      },
    ],
  },
  {
    name: "Alarms and Functional Checks",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "No alarms or communication faults from any thruster controller",
        isChecked: false,
      },
      {
        id: "4",
        label: "No performance degradation or unexplained response delay observed",
        isChecked: false,
      },
    ],
  },
];

export const dpWorkstationsChecklist: ICheckListData[] = [
  {
    name: "Workstation Health Status",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "All DP workstations are operating normally",
        isChecked: false,
      },
      {
        id: "2",
        label: "No system-level alarms or event logs noted",
        isChecked: false,
      },
    ],
  },
  {
    name: "Performance and Redundancy",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "At least two operator stations active (redundancy maintained)",
        isChecked: false,
      },
      {
        id: "4",
        label: "No signs of poor performance or abnormal behavior",
        isChecked: false,
      },
    ],
  },
];

export const dpNetworkChecklist: ICheckListData[] = [
  {
    name: "Network Redundancy",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "Both DP networks (A & B) are online and synchronized",
        isChecked: false,
      },
      {
        id: "2",
        label: "No network performance degradation detected",
        isChecked: false,
      },
    ],
  },
  {
    name: "Faults and Failover Readiness",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "No active alarms on either DP network",
        isChecked: false,
      },
      {
        id: "4",
        label: "System remains operational if one network is lost",
        isChecked: false,
      },
    ],
  },
];

export const dpPositionReferenceChecklist: ICheckListData[] = [
  {
    name: "System Configuration",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "SceneScan and RangeGuard are active and configured as required",
        isChecked: false,
      },
      {
        id: "2",
        label: "Most reliable DGNSS is enabled and synchronized",
        isChecked: false,
      },
    ],
  },
  {
    name: "System Status and Alerts",
    isChecked: false,
    list: [
      {
        id: "3",
        label: "No PRS performance degradation or alarms",
        isChecked: false,
      },
      {
        id: "4",
        label: "At least three PRS systems are operational and verified",
        isChecked: false,
      },
    ],
  },
];

export const fireChecklist: ICheckListData[] = [
  {
    name: "Fire Safety Status",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "No fire alarms are active",
        isChecked: false,
      },
      {
        id: "2",
        label: "No fire has been confirmed in any vessel zone",
        isChecked: false,
      },
      {
        id: "3",
        label: "All firefighting systems are operational",
        isChecked: false,
      },
      {
        id: "4",
        label: "Emergency response team on standby with no active incident",
        isChecked: false,
      },
    ],
  },
];

export const floodChecklist: ICheckListData[] = [
  {
    name: "Flooding Risk Assessment",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "No bilge alarms are currently active",
        isChecked: false,
      },
      {
        id: "2",
        label: "No confirmed signs of flooding in any compartment",
        isChecked: false,
      },
      {
        id: "3",
        label: "Bilge pumps and level indicators functioning normally",
        isChecked: false,
      },
      {
        id: "4",
        label: "Flood control procedures reviewed and ready",
        isChecked: false,
      },
    ],
  },
];

export const collisionChecklist: ICheckListData[] = [
  {
    name: "Collision Avoidance Status",
    isChecked: false,
    list: [
      {
        id: "1",
        label: "No collision risk identified by DP system or radar",
        isChecked: false,
      },
      {
        id: "2",
        label: "No errant vessel within 150m minimum approach distance",
        isChecked: false,
      },
      {
        id: "3",
        label: "DP operator has clear visibility and full situational awareness",
        isChecked: false,
      },
      {
        id: "4",
        label: "Bridge team confirms no reported marine traffic hazard",
        isChecked: false,
      },
    ],
  },
];
